import { useIntl } from 'react-intl';
import { Selector } from 'sonata-react-components';

import type { SelectorOptionPropsInterface } from 'sonata-react-components';

type Props = {
  accounts?: { _id: string; name: string }[];
  id: string;
  onFilterStatus?: (state: { id: string; value: any }[]) => { id: string; value: any }[];
  value?: string[];
};

export default function AccountSelector({ accounts, id, onFilterStatus, value }: Props) {
  const { formatMessage } = useIntl();

  const options: SelectorOptionPropsInterface[] =
    accounts?.map(({ _id, name }) => ({
      id: _id,
      label: name
    })) || [];

  const selectedValue: SelectorOptionPropsInterface[] =
    accounts
      ?.filter(({ _id }) => value?.includes(_id))
      ?.map(({ _id, name }) => ({
        id: _id,
        label: name
      })) || [];

  const handleChange = (changedSelectedOptions: SelectorOptionPropsInterface[]) => {
    onFilterStatus?.([
      {
        id: 'accounts',
        value: changedSelectedOptions.length
          ? changedSelectedOptions.map(({ id: selectedOptionId }) => selectedOptionId.toString())
          : undefined
      }
    ]);
  };

  return (
    <Selector<SelectorOptionPropsInterface[]>
      id={`${id}_selector`}
      label={formatMessage({
        defaultMessage: 'Sonata Account',
        id: 'deviatedLineItems.filters.account.label'
      })}
      onChange={handleChange}
      options={options}
      showDeselectOption
      showSelectedItems={false}
      type="multiple"
      value={selectedValue}
    />
  );
}
